function getConvertHistoricalData() {
  const experiments_user_saw =
    window.convert?.historicalData?.experiments ?? [];

  const goals = {
    100030251: "Form field engagement (Test16)",
    100030182: "Clicks on the telephone number",
    100030181: "Clicks on the free trial button",
    100029214: "Vorne Page View",
    100029121: "Package downloads",
    100029120: "Email signups",
    100029099: "Time on page",
    100029016: "Clicks on control banner CTA (Control Only)",
    100029004: "Clicks on the download CTA",
    100028843: "Free trial form submit",
    100028825: "Visits to the free trial signup page",
    100028824: "Free trial conversions",
    100028468: "Increase Engagement",
    100028467: "Decrease BounceRate",
  };

  const experiments = [];
  if (Object.keys(experiments_user_saw).length > 0) {
    Object.keys(experiments_user_saw).forEach(function (item) {
      const goals_triggered_list = [];
      Object.keys(experiments_user_saw[item].goals).forEach(function (goal) {
        goals_triggered_list.push(goals[goal]);
      });

      const experiment = {
        experiment_name: window.convert.data.experiments[item].n,
        variation_name: experiments_user_saw[item].variation_name,
        goals_triggered: goals_triggered_list,
      };

      experiments.push(experiment);
    });
  }

  return experiments;
}

export { getConvertHistoricalData };
